window.initHenceNativeAdapter = function initHenceNativeAdapter(root) {
 if(!root)return () => {};
 const controller=new AbortController();
 const section=root.querySelector('#preparation'),stage=root.querySelector('.hero-study-stage'),products=root.querySelector('.hero-study-products');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:760px)');
 const smooth=(a,b,p)=>{const t=Math.max(0,Math.min(1,(p-a)/(b-a)));return t*t*(3-2*t)};
 const benefits=[...products.querySelectorAll('.hero-benefits li')];
 const footer=document.createElement('div');footer.className='phase1-mobile-footer';stage.append(footer);
 const rating=stage.querySelector('.hero-rating'),actions=stage.querySelector('.opening-actions'),gift=products.querySelector('.hero-study-gift');
 const slots=[rating,actions,gift].map(node=>{const marker=document.createComment('native hero mobile slot');node.before(marker);return [node,marker]});
 const headline=stage.querySelector('h1');
 function syncMobile(){
  if(mobile.matches){headline.firstChild.nodeValue='Ready, set... ';slots.forEach(([node])=>footer.append(node));}
  else{headline.firstChild.nodeValue='Ready. Set. ';slots.forEach(([node,marker])=>marker.after(node));}
  root.dataset.phase1Mobile=mobile.matches?'portrait':'';
  measure();
 }
 function measure(){
  const header=document.querySelector('.shopify-section-header-sticky,.header-wrapper,.section-header');
  const top=header?.getBoundingClientRect().height||83;
  root.style.setProperty('--hero-study-top',`${top}px`);
  root.style.setProperty('--hero-study-mobile-height',`${stage.offsetHeight}px`);
  root.style.setProperty('--phase1-copy-height',`${stage.querySelector('.opening-copy').offsetHeight}px`);
  const scene=products.querySelector('.mix-scene');
  if(scene){products.style.setProperty('--pair-scene-height',`${scene.offsetHeight}px`);products.style.setProperty('--pair-bottom',`${products.offsetHeight-scene.offsetTop-scene.offsetHeight*.48}px`);}
 }
 let lastProgress=-1;
 function update(){
  const p=parseFloat(stage.style.getPropertyValue('--mix-progress'))||0;
  if(p===lastProgress)return;lastProgress=p;
  const splash=products.querySelector('.hero-splash-backdrop');
  const sceneProgress=Math.max(0,Math.min(100,(p-6)/.72));
  splash.style.opacity=(.9-.65*smooth(8,96,sceneProgress)).toFixed(3);
  products.style.setProperty('--pair-progress',smooth(78,92,p).toFixed(4));
  products.style.setProperty('--product-points',smooth(62,70,p).toFixed(4));
  benefits.forEach((item,index)=>item.classList.toggle('is-revealed',p>=[0,10,24,40][index]));
 }
 const mutation=new MutationObserver(update);mutation.observe(stage,{attributes:true,attributeFilter:['style']});
 mobile.addEventListener('change',syncMobile,{signal:controller.signal});addEventListener('resize',measure,{passive:true,signal:controller.signal});
 const resize=new ResizeObserver(measure);resize.observe(products);
 syncMobile();update();
 // A narrow drift of the master artwork only while visible and allowed.
 const splash=products.querySelector('.hero-splash-backdrop');let visible=false,frame=0,start=0;
 const allowed=()=>visible&&!document.hidden&&!reduced.matches;
 function tick(now){frame=0;if(!allowed())return;start||=now;const t=(now-start)/1000;splash.style.setProperty('--p1-x',`${(Math.sin(t*.23)*.35).toFixed(3)}px`);splash.style.setProperty('--p1-y',`${(Math.sin(t*.34)*.45).toFixed(3)}px`);frame=requestAnimationFrame(tick)}
 function motion(){if(!allowed()){if(frame)cancelAnimationFrame(frame);frame=0;start=0;splash.style.removeProperty('--p1-x');splash.style.removeProperty('--p1-y')}else if(!frame)frame=requestAnimationFrame(tick)}
 const observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;motion()});observer.observe(section);
 document.addEventListener('visibilitychange',motion,{signal:controller.signal});reduced.addEventListener('change',motion,{signal:controller.signal});
 return () => {controller.abort();mutation.disconnect();resize.disconnect();observer.disconnect();if(frame)cancelAnimationFrame(frame);slots.forEach(([node,marker])=>{marker.after(node);marker.remove()});footer.remove();};
};

// Shopify may replace a section during editor changes. Initialize the fresh DOM and
// release every observer/listener associated with the previous element.
(() => {
 window.__henceNativeHeroBootstrap?.dispose();
 const controller=new AbortController();let active=null;
 function dispose(){if(!active)return;active.cleanups.reverse().forEach(clean=>clean?.());delete active.root.dataset.heroLive;active=null;}
 function boot(){const root=document.querySelector('.hence-native-hero');if(!root||active?.root===root)return;dispose();root.dataset.heroLive='true';active={root,cleanups:[window.initHenceNativeMix(root),window.initHencePhase1Hero(root),window.initHenceNativeAdapter(root)]};}
 document.addEventListener('shopify:section:unload',event=>{if(active&&event.target.contains(active.root))dispose()},{signal:controller.signal});
 document.addEventListener('shopify:section:load',()=>boot(),{signal:controller.signal});
 window.__henceNativeHeroBootstrap={dispose:()=>{dispose();controller.abort();}};
 boot();
})();
